import { AuthRoleIdEnum } from 'constants/user'
import { AuthUserProfile } from 'types/auth'

/**
 * Check if a user can create collections based on their role and permissions
 */
export function canUserCreateCollections(user: AuthUserProfile): boolean {
  // Admins and Org Admins can always create collections
  if (user.authRoleId === AuthRoleIdEnum.ORG_ADMIN || user.authRoleId === AuthRoleIdEnum.ADMIN) {
    return true
  }

  // Basic users can create collections if they have the permission flag enabled
  if (user.authRoleId === AuthRoleIdEnum.BASIC_USER) {
    return user.canCreateCollections ?? false
  }

  return false
}
